import { NgModule } from '@angular/core';
import { RSCommonModule } from 'src/app/core/feature-modules/facade.module';
import { AbpTabPostComponent } from './abp-tab-post.component';
import { LocationsListModule } from 'src/app/core/feature-modules/locations-list/locations-list.module';
import { ProgressrModule } from 'src/app/core/feature-modules/progress/progress.module';
import { components as postCreateComponents } from './components/abp-post-create';
import { UploadMediaModule } from 'src/app/core/feature-modules/upload-media/upload-media.module';
import { TableFilterModule } from 'src/app/core/feature-modules/table-filter/table-filter.module';
import { ActivityStatusModule } from '../pipes/activity-status.module';
import { GetStatusModule } from '../pipes/get-status.module';
import { AbpDateLocationsFormModule } from '../components/abp-date-locations-form/abp-date-locations-form.module';
import { AbpPostDeleteComponent } from './components/abp-post-delete/abp-post-delete.component';
import { AbpPostLocationsComponent } from './components/abp-post-locations/abp-post-locations.component';
import { AbpUtmFormModule } from '../components/abp-utm-form/abp-utm-form.module';
import { AbpPostEditComponent } from './components/abp-post-edit/abp-post-edit.component';
import { SubmitComponent } from './components/abp-post-create/submit/submit.component';

export const MODULES = [
  LocationsListModule,
  ProgressrModule,
  UploadMediaModule,
  AbpDateLocationsFormModule,
  TableFilterModule,
  ActivityStatusModule,
  GetStatusModule,
  AbpUtmFormModule,
];
export const COMPONENTS = [AbpPostDeleteComponent, AbpPostLocationsComponent, ...postCreateComponents];

@NgModule({
  imports: [RSCommonModule, ...MODULES],
  declarations: [AbpTabPostComponent, ...COMPONENTS, AbpPostEditComponent],
  exports: [AbpTabPostComponent, SubmitComponent],
})
export class AbpPostModule {}
